module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "runners"
  }, [_c('box', [_c('box-header', {
    attrs: {
      "title": ("RUNNERS (" + (_vm.runners.length) + ")")
    }
  }), _vm._v(" "), _c('box-content', [_c('runners-list', {
    attrs: {
      "runners": _vm.runners
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51824ed9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RunnersResume.vue
// module id = 1819
// module chunks = 1